// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const env = (key, fallback) => {
  const value = process.env[key];
  return value && String(value).trim() ? String(value).trim() : fallback;
};

const firebaseConfig = {
  apiKey: env(
    "REACT_APP_FIREBASE_CLIENT_API_KEY",
    "AIzaSyD3BH19nlFKBIutOR2RS4MBfv3cDubD39o"
  ),
  authDomain: env(
    "REACT_APP_FIREBASE_CLIENT_AUTH_DOMAIN",
    "simplerenovate-1b5ed.firebaseapp.com"
  ),
  projectId: env("REACT_APP_FIREBASE_CLIENT_PROJECT_ID", "simplerenovate-1b5ed"),
  storageBucket: env(
    "REACT_APP_FIREBASE_CLIENT_STORAGE_BUCKET",
    "simplerenovate-1b5ed.appspot.com"
  ),
  messagingSenderId: env(
    "REACT_APP_FIREBASE_CLIENT_MESSAGING_SENDER_ID",
    "717763838069"
  ),
  appId: env(
    "REACT_APP_FIREBASE_CLIENT_APP_ID",
    "1:717763838069:web:fa7ef10dba2d23b690b83c"
  ),
};

const firebaseConfigPro = {
  apiKey: env(
    "REACT_APP_FIREBASE_PRO_API_KEY",
    "AIzaSyADtWYgLGTmu1b_1ipAgQB_2oBoJ5jKQmo"
  ),
  authDomain: env(
    "REACT_APP_FIREBASE_PRO_AUTH_DOMAIN",
    "sr-for-pros.firebaseapp.com"
  ),
  projectId: env("REACT_APP_FIREBASE_PRO_PROJECT_ID", "sr-for-pros"),
  storageBucket: env(
    "REACT_APP_FIREBASE_PRO_STORAGE_BUCKET",
    "sr-for-pros.firebasestorage.app"
  ),
  messagingSenderId: env(
    "REACT_APP_FIREBASE_PRO_MESSAGING_SENDER_ID",
    "314233115921"
  ),
  appId: env(
    "REACT_APP_FIREBASE_PRO_APP_ID",
    "1:314233115921:web:d8fe70e0c6b155db93e8b0"
  ),
};

const app = initializeApp(firebaseConfig);
const app2 = initializeApp(firebaseConfigPro, "professional");

const auth = getAuth(app);
const auth2 = getAuth(app2);
const provider = new GoogleAuthProvider();

// Apple Sign-In: bundled sr-for-pros web API key is not valid for Identity Toolkit.
// Use the main SimpleRenovate Firebase project (valid key + localhost authorized).
// Set REACT_APP_USE_PRO_FIREBASE_APPLE=true after updating REACT_APP_FIREBASE_PRO_API_KEY.
const useProFirebaseForApple =
  process.env.REACT_APP_USE_PRO_FIREBASE_APPLE === "true";
const appleAuth = useProFirebaseForApple ? auth2 : auth;

export { getToken, onMessage, auth, auth2, appleAuth, provider };
